import React, { useState, useEffect } from 'react';

const AboutSection = ({ siteData, updateSiteData, setSiteData, showSaveStatus }) => {
    const [localAbout, setLocalAbout] = useState(siteData.about);
    const [hasChanges, setHasChanges] = useState(false);
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        setLocalAbout(siteData.about);
        setHasChanges(false);
    }, [siteData.about]);

    const handleLocalUpdate = (field, value) => {
        setLocalAbout(prev => ({
            ...prev,
            [field]: value
        }));
        setHasChanges(true);
    };

    const handleSave = async () => {
        try {
            setSaving(true);
            setSiteData(prev => ({
                ...prev,
                about: localAbout
            }));

            await updateSiteData('about', localAbout);
            showSaveStatus('About section updated successfully!');
            setHasChanges(false);
        } catch (error) {
            console.error('Failed to update about:', error);
            showSaveStatus('Failed to update about section', true);
        } finally {
            setSaving(false);
        }
    };

    return (
        <div className="space-y-6">
            <div className="flex justify-between items-center">
                <h3 className="text-xl font-semibold text-stone-800">About Section</h3>
                <button
                    onClick={handleSave}
                    disabled={!hasChanges || saving}
                    className={`px-6 py-2 rounded-lg font-medium transition-colors ${hasChanges && !saving
                        ? 'bg-amber-500 text-white hover:bg-amber-600'
                        : 'bg-stone-300 text-stone-500 cursor-not-allowed'
                        }`}
                >
                    {saving ? 'Saving...' : hasChanges ? 'Save Changes' : 'No Changes'}
                </button>
            </div>

            <div>
                <label className="block text-sm font-medium text-stone-700 mb-2">Title</label>
                <input
                    type="text"
                    value={localAbout.title}
                    onChange={(e) => handleLocalUpdate('title', e.target.value)}
                    className="w-full px-4 py-3 border border-stone-300 rounded-lg focus:ring-2 focus:ring-amber-400 focus:border-transparent"
                />
            </div>

            <div>
                <label className="block text-sm font-medium text-stone-700 mb-2">Content</label>
                <textarea
                    value={localAbout.content}
                    onChange={(e) => handleLocalUpdate('content', e.target.value)}
                    className="w-full px-4 py-3 border border-stone-300 rounded-lg focus:ring-2 focus:ring-amber-400 focus:border-transparent"
                    rows="5"
                />
            </div>
        </div>
    );
};

export default AboutSection;